import { render, staticRenderFns } from "./vipDetail.vue?vue&type=template&id=0c3e328a&scoped=true"
import script from "./vipDetail.vue?vue&type=script&lang=js"
export * from "./vipDetail.vue?vue&type=script&lang=js"
import style0 from "./vipDetail.vue?vue&type=style&index=0&id=0c3e328a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3e328a",
  null
  
)

export default component.exports